// extracted by mini-css-extract-plugin
export default {"menuSelection":"MenuSelection_menuSelection__yY9pT","isActive":"MenuSelection_isActive__0wkF9"};